import {
  IPayerResponse,
  IRequirementResponse
} from "@wingspanhq/payments/dist/interfaces";
import { ContextItem } from "../../../../types";
import { WSQueryCache } from "@ws-react-query";
import { QUERY_PAYER } from "../../../../../../query/payers/keys";

export const getRequirementPayerFromCache = (
  requirement: IRequirementResponse,
  contextItem: ContextItem
): IPayerResponse | undefined => {
  return WSQueryCache.getQueryData<IPayerResponse>([
    QUERY_PAYER,
    requirement.payerId
  ]);
};
